import React, { useMemo } from 'react';
import { Box } from '@mui/system';
import { Loading } from 'components';
import { useEmissionsAllocation } from 'hooks';
import { AllocationSetupsTable, SETUPS_OVERVIEW_COLUMNS } from './components';

export const SetupsOverview = ({ onViewDetails }: { onViewDetails: (allocationId: number) => void }) => {
    const { data: emissions, isLoading } = useEmissionsAllocation();
    const columns = useMemo(() => SETUPS_OVERVIEW_COLUMNS, []);

    if (isLoading) return <Loading />;

    return (
        <Box sx={{ display: 'flex', width: '100%' }} aria-label="Emissions Allocation Setups Overview">
            {emissions && <AllocationSetupsTable data={emissions} columns={columns} onViewDetails={onViewDetails} />}
        </Box>
    );
};